export * from './html/core';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-drawing/dist/es/html.js
// module id = 1399
// module chunks = 0